import PropTypes from "prop-types";

// Delete component for confirming project deletion
// This component displays a modal dialog asking the user to confirm if they want to delete a project
const Delete = ({ onConfirm, onCancel, busy }) => (
  <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.7)" }} tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content bg-dark text-light border border-secondary shadow-lg">
        <div className="modal-header border-secondary">
          <h5 className="modal-title">Confirm Delete</h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={onCancel}
            aria-label="Close"
          />
        </div>

        <div className="modal-body">
          <p>
            Are you sure you want to delete this project? <br />
            <strong>This action cannot be undone.</strong>
          </p>
        </div>

        <div className="modal-footer border-secondary">
          <button className="btn btn-outline-light" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={onConfirm} disabled={busy}>
            {busy ? "Deleting…" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  </div>
);

// Delete component for confirming project deletion
Delete.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  busy: PropTypes.bool,
};

// Default props for Delete component
Delete.defaultProps = { busy: false };

export default Delete;
